var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { i18n } from '@lingui/core';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { map } from 'lit/directives/map.js';
import { range } from 'lit/directives/range.js';
import { activateI18n } from '../i18n.js';
import { messages as daMessages } from './locales/da/messages.mjs';
import { messages as enMessages } from './locales/en/messages.mjs';
import { messages as fiMessages } from './locales/fi/messages.mjs';
import { messages as nbMessages } from './locales/nb/messages.mjs';
import { messages as svMessages } from './locales/sv/messages.mjs';
import { styles } from './style.js';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);
/**
 * A page indicator component that displays a series of dots representing pages.
 *
 * One dot is highlighted to indicate the currently selected page.
 */
class WarpPageIndicator extends LitElement {
    static { this.styles = [styles]; }
    /** Validated page count (minimum 1) */
    get _validPageCount() {
        return Math.max(1, Math.floor(this.pageCount ?? 1));
    }
    /** Validated selected page (clamped to valid range) */
    get _validSelectedPage() {
        const page = Math.floor(this.selectedPage ?? 1);
        return Math.max(1, Math.min(page, this._validPageCount));
    }
    render() {
        const pageCount = this._validPageCount;
        const selectedPage = this._validSelectedPage;
        const groupLabel = i18n._({
            id: 'page-indicator.aria.label',
            comment: 'Default screenreader message for page indicator group',
            message: 'Dot {selectedPage} is highlighted in a row of {pageCount} dots',
            values: { selectedPage, pageCount },
        });
        return html `
      <div class="w-page-indicator" role="img" aria-label="${groupLabel}">
        <div class="w-page-indicator--container">
          ${map(range(pageCount), (i) => {
            const pageNumber = i + 1;
            const isSelected = pageNumber === selectedPage;
            const classes = {
                'w-page-indicator--dot': true,
                'w-page-indicator--selecteddot': isSelected,
            };
            return html `<div class="${classMap(classes)}"></div>`;
        })}
        </div>
      </div>
    `;
    }
}
__decorate([
    property({ type: Number, attribute: 'selected-page', reflect: true })
], WarpPageIndicator.prototype, "selectedPage", void 0);
__decorate([
    property({ type: Number, attribute: 'page-count', reflect: true })
], WarpPageIndicator.prototype, "pageCount", void 0);
if (!customElements.get('w-page-indicator')) {
    customElements.define('w-page-indicator', WarpPageIndicator);
}
export { WarpPageIndicator };
//# sourceMappingURL=page-indicator.js.map